import { render, staticRenderFns } from "./vip-secret.vue?vue&type=template&id=5f55e74f&scoped=true&"
import script from "./vip-secret.vue?vue&type=script&lang=js&"
export * from "./vip-secret.vue?vue&type=script&lang=js&"
import style0 from "./vip-secret.vue?vue&type=style&index=0&id=5f55e74f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55e74f",
  null
  
)

export default component.exports